"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSummaryDataFile = exports.getDataDirectory = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var getDataDirectory = function getDataDirectory(url) {
  return _axios.default.get(url, {
    params: {
      ts: (0, _moment.default)().unix().toString()
    }
  }).then(function (response) {
    return response.data;
  });
};

exports.getDataDirectory = getDataDirectory;

var getSummaryDataFile = function getSummaryDataFile(url) {
  return _axios.default.get(url).then(function (response) {
    return response.data.summaryFileData;
  });
};

exports.getSummaryDataFile = getSummaryDataFile;